'use client'

import {Media} from "@/lib/types";
import {useCallback, useEffect, useState} from "react";
import classNames from "classnames";

export function MediaGallery({medias, format}: { medias?: Media[], format?: 'compact' | string }) {
  const [list, setList] = useState<Media[]>([]);
  const [active, setActive] = useState<number>(0);

  useEffect(() => {
    if (medias && medias.length > 0) {
      setList(medias.sort((a, b) => a.media_position - b.media_position))
    } else {
      setList([{media_id: 'logo', media_url: '/images/logo.png', media_position: 0, media_type: 'picture'}])
    }
  }, [medias]);


  const renderListItem = useCallback((m: Media) => <div
    key={'gm-' + m.media_id}
    className={classNames("h-auto max-h-32 max-w-full rounded-lg bg-gray-100 overflow-hidden", {'hover:cursor-pointer': format !== 'compact'})}
    onClick={() => setActive(_ => list.findIndex(l => l.media_id == m.media_id))}>
    <img className={classNames("object-cover lg:object-fill  ", {'lg:h-32 lg:w-64': format !== 'compact'})}
         src={m.media_url} alt={m.media_id}/>
  </div>, [list, format])

  return (<div className="grid gap-4">
    {format !== 'compact' && <div className="hidden lg:block h-auto max-w-full rounded-lg bg-gray-100 m-auto">
      {list[active] && <img className="h-96 object-cover "
                            src={list[active].media_url} alt={list[active].media_id}/>}
    </div>}

    <div
      className={classNames("grid grid-cols-2  gap-4", {'lg:grid-cols-5': format !== 'compact'}, {'lg:grid-cols-2': format === 'compact'})}>
      {list.map(m => renderListItem(m))}
    </div>
  </div>)
}